import { Box, colors, IconButton } from '@mui/material'
import { useContext } from 'react'
import { FaUserCircle } from 'react-icons/fa'

import { AuthenticationContext } from '../Contexts'

const UserIcon: React.FC = () => {
  const { auth, authEntity, signIn, signOut } = useContext(AuthenticationContext)
  const iconColor = auth?.authenticated() ? (authEntity?.admin ? colors.lightBlue[500] : colors.green[500]) : colors.grey[500]
  const iconHint = auth?.authenticated() ? `Signed In (${auth?.address()?.toShortString()})` : 'Signed Out'

  const onClick = async () => {
    if (auth?.authenticated()) {
      signOut?.()
    } else {
      await signIn?.()
    }
  }

  return (
    <Box alignItems="center" display="flex" justifyContent="center">
      <IconButton disabled={!auth} onClick={onClick} style={{ padding: '6px' }} title={iconHint}>
        <FaUserCircle color={iconColor} />
      </IconButton>
    </Box>
  )
}

export default UserIcon
